import { useEffect, useState } from 'react';

interface UseWriteOnTextEffectProps {
  finalText: string;
  delay: number;
}

export const useWriteOnTextEffect = (props: UseWriteOnTextEffectProps) => {
  const { finalText, delay } = props;
  const [text, setText] = useState<string>('');

  useEffect(() => {
    let currentTitle = '';
    let interval: NodeJS.Timeout;

    if (finalText.length === 0) {
      return;
    }

    interval = setInterval(() => {
      if (currentTitle.length !== finalText.length) {
        const newLetter = finalText[currentTitle.length];
        currentTitle += newLetter;
        setText(currentTitle);
      } else {
        clearInterval(interval);
      }
    }, delay);

    return () => clearInterval(interval);
  }, [delay, finalText]);

  return { text };
};
